import { render, staticRenderFns } from "./formModal.vue?vue&type=template&id=afa62b46&scoped=true&"
import script from "./formModal.vue?vue&type=script&lang=js&"
export * from "./formModal.vue?vue&type=script&lang=js&"
import style0 from "./formModal.vue?vue&type=style&index=0&id=afa62b46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa62b46",
  null
  
)

export default component.exports